<!-- =========================================================================================
    File Name: TableMiscellaneous.vue
    Description: Combine filter,sorter, pagination etc.
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vx-card title="Payment Account List">
    <!-- <p>
      You can add a
      <strong>filtered, sorted, paginated and multi selected</strong> table with combination of the
      <code>search</code>,
      <code>multiple</code> and
      <code>pagination</code> properties for example
    </p>-->
    <!-- <br /> -->
    <vs-button
      color="primary"
      type="border"
      icon="add"
      to="paymentAccount/create"
      >Create Payment Account</vs-button
    >
    <vs-table
      v-model="selected"
      stripe
      pagination
      max-items="10"
      search
      :data="payments"
      id="button-with-loading"
    >
      <template slot="thead">
        <vs-th sort-key="title">Bank</vs-th>
        <vs-th sort-key="description">Account Number</vs-th>
        <vs-th sort-key="requirement">Name</vs-th>

        <vs-th sort-key="title">Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="tr.bank">{{ tr.bank.name }}</vs-td>
          <vs-td :data="tr.account_number">{{ tr.account_number }}</vs-td>
          <vs-td :data="tr.name">{{ tr.name }}</vs-td>
          <vs-td>
            <div class="flex">
              <vs-button
                type="border"
                size="small"
                icon-pack="feather"
                icon="icon-edit"
                color="warning"
                class="mr-2"
                @click="editPaymentAccount(tr.id)"
              >
              </vs-button>
              <vs-button
                type="border"
                size="small"
                icon-pack="feather"
                icon="icon-trash"
                color="danger"
                @click="deleteAlert('danger', tr.id)"
              ></vs-button>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <!-- <prism language="js" class="rounded-lg">{{ selected }}</prism> -->
  </vx-card>
</template>

<script>
import axios from '../../../axios110'
import Prism from 'vue-prism-component'
import moment from 'moment'
import router from '../../../router'
export default {
  data() {
    return {
      'selected': [],
      'tableList': [
        'vs-th: Component',
        'vs-tr: Component',
        'vs-td: Component',
        'thread: Slot',
        'tbody: Slot',
        'header: Slot'
      ],
      'payments': [],
      'colorAlert': 'primary',
      'titleAlert': 'Alert',
      'activeAlert': false,
      'valueInput': '',
      'userAuth': this.$store.getters.userAuth,
      'deleteId': null,
      page: 1,
      limit: 10,

    }
  },
  mounted() {
    //console.log('ini mounted')
    this.$vs.loading({
      background: this.backgroundLoading,
      color: this.colorLoading,
      container: "#button-with-loading",
      scale: 0.45
    })
    //axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.getters.tokenAuth
    axios.get(`/ecommerce/web/payment_account/byStore/${this.userAuth.company.id}?limit=100`, {})
      .then(res => {
        if (res.status != 200) {
          console.log(res.status)
          //   this.errorRecover = true
          //   this.messageRecover = 'Email tidak terdaftar!'
        } else {
          console.log(res)
          this.payments = res.data
        }
        this.$vs.loading.close("#button-with-loading > .con-vs-loading")

      })
      .catch(error => {
        console.log(error.response)
        this.$vs.loading.close("#button-with-loading > .con-vs-loading")
      })
  },
  methods: {

    format_date(value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DD')
      }
    },
    limitChar(str) {
      var output = ''
      if (str.length > 100) {
        str = str.substring(0, 100)
        output = str + '...'
      } else {
        output = str
      }
      return output
    },
    deleteAlert(color, id) {
      this.colorAlert = color
      this.deleteId = id
      console.log(`masuk delete${this.deleteId}`)
      this.$vs.dialog({
        color: this.colorAlert,
        title: 'Apa anda yakin?',
        text: 'Setelah dihapus data ini tidak bisa diakses lagi',
        accept: this.deletePaymentAccount
      })
    },

    deletePaymentAccount() {
      console.log(`masuk delete${this.deleteId}`)
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading",
        scale: 0.45
      })
      axios.delete(`/ecommerce/web/payment_account/${this.deleteId}`, {})
        .then(res => {
          if (res.status != 200) {
            console.log(res.status)
            //   this.errorRecover = true
            //   this.messageRecover = 'Email tidak terdaftar!'
          } else {
            const index = this.payments.findIndex(payment => payment.id === this.deleteId) // find the post index 
            if (~index) // if the post exists in array
              this.payments.splice(index, 1) //delete the post
            console.log(res)

          }
          this.$vs.loading.close("#button-with-loading > .con-vs-loading")

          this.$vs.notify({
            color: 'success',
            title: 'Berhasil!',
            text: 'Berhasil hapus payment account'
          })

        })
        .catch(error => {
          console.log(error.response)
          this.$vs.loading.close("#button-with-loading > .con-vs-loading")
        })


    },
    editPaymentAccount(id) {
      console.log(id)
      this.$router.push(`/paymentAccount/edit/${id}`)
    },
    handleSelected(tr) {
      this.$router.push(`/payment/${tr.id}/applicant`)
    }

  },
  components: {
    Prism
  }
}
</script>
